export const missionStatus = {
    LIVE: 10,
    WIP: 1,
    DRAFT: 0,
    OPEN_FOR_BETA: 15,
    SUBSCRIBE_FOR_RELEASE: 20
}